<!-- eslint-disable vue/multi-word-component-names -->
<!--
 * @Description: 教务系统 课程管理 查看
 * @Author: PF
 * @Date: 2022-09-23 11:53:38
 * @LastEditors: PF
 * @LastEditTime: 2024-01-30 17:33:08
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon"><Document /></el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions title="基本信息" :column="4" border>
        <el-descriptions-item label="课程" label-align="right" align="left" width="100px" span="2">{{ruleForm.kcmc}}</el-descriptions-item>
        <el-descriptions-item label="教学单元" label-align="right" align="left" width="100px" span="2">{{ruleForm.jxdybt}}</el-descriptions-item>
        <el-descriptions-item label="教学内容" label-align="right" align="left" width="100px" span="2">{{ruleForm.jxnrbt}}</el-descriptions-item>
      </el-descriptions>
      <div>
        <div class="el-descriptions__header"><div class="el-descriptions__title">作业内容</div></div>
        <el-descriptions-item label="总分" label-align="right" align="left" label-class-name="label-name" >{{ruleForm.zf}}</el-descriptions-item>
        <el-table :data="ruleForm.xszys" class="wp100" border height="100%">
          <el-table-column label="序号" type="index" width="80" fixed align="center" label-class-name="label-name" />
          <el-table-column prop="txbt" label="题型" align="center" label-class-name="label-name" show-overflow-tooltip></el-table-column>
          <el-table-column prop="stzw" label="试题正文" align="center" label-class-name="label-name" show-overflow-tooltip>
            <template #default="scope">
              <p style="white-space: pre-wrap; text-indent:0;" v-html="scope.row.stzw"></p>
            </template>
          </el-table-column>
          <el-table-column prop="fz" label="分值" align="center" label-class-name="label-name" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect } from '@/api/common.js'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const ruleForm = ref({ zylx: {}, xszys: [], xxzy: {}, zyfbbjs: [] })
const emits = defineEmits(['update:openDetail'])

const zylxData = ref({ list: [] })
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadSelect({ url: '/api/v2/ziyuanku/zuoye/zuoyeleixing', data: zylxData })
      loadData({ url: '/api/v2/ziyuanku/zuoye/' + props.row.id, ruleForm })
    }
  }, { deep: true, immediate: true })
</script>
<style lang="less" scoped>
  :deep(.label-name) {
    width: 200px;
  }
</style>
